"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _minusButton = require("../../../img/minus-button.png");

var _minusButton2 = _interopRequireDefault(_minusButton);

var _plusButton = require("../../../img/plus-button.png");

var _plusButton2 = _interopRequireDefault(_plusButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Counter2 = function (_React$Component) {
    _inherits(Counter2, _React$Component);

    function Counter2(props) {
        _classCallCheck(this, Counter2);

        var _this = _possibleConstructorReturn(this, (Counter2.__proto__ || Object.getPrototypeOf(Counter2)).call(this, props));

        _this.state = {
            selectValue: '1'
        };

        _this.increment = _this.increment.bind(_this);
        _this.decrement = _this.decrement.bind(_this);
        return _this;
    }

    _createClass(Counter2, [{
        key: "UNSAFE_componentWillMount",
        value: function UNSAFE_componentWillMount() {
            this.setState({
                selectValue: this.props.currentValue
            });
        }
    }, {
        key: "UNSAFE_componentWillReceiveProps",
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            this.setState({
                selectValue: nextProps.currentValue
            });
        }
    }, {
        key: "increment",
        value: function increment(e) {
            var _this2 = this;

            this.setState(function (state, props) {

                var oldVal = state.selectValue;
                var max = props.max;
                var isRestrictedSelection = props.isRestrictedSelection;

                if (max > 0 && isRestrictedSelection) {
                    return { selectValue: oldVal + 1 };
                } else if (!isRestrictedSelection) {
                    return { selectValue: oldVal + 1 };
                }
            }, function () {
                _this2.props.callbackParent(_this2.state.selectValue, _this2.props.forOption);
            });
        }
    }, {
        key: "decrement",
        value: function decrement(e) {
            var _this3 = this;

            this.setState(function (state, props) {
                var oldVal = state.selectValue;
                var min = props.min;

                if (oldVal > min) {
                    return { selectValue: oldVal - 1 };
                }
            }, function () {
                _this3.props.callbackParent(_this3.state.selectValue, _this3.props.forOption);
            });
        }
    }, {
        key: "render",
        value: function render() {
            var classNames = this.props.disabled ? "btn btn-default disabled " : "btn btn-default";
            var buttonClass = " counter-button";

            return _react2.default.createElement(
                "div",
                { className: "btn-group1 ctr2 pull-right", role: "group", "aria-label": "..." },
                _react2.default.createElement(
                    "button",
                    { type: "button", className: classNames + buttonClass + " btn-button-link", onClick: this.decrement, tabIndex: 0 },
                    _react2.default.createElement("img", { src: _minusButton2.default, className: "minusButton", alt: "Decrease Item Quantity" })
                ),
                _react2.default.createElement(
                    "button",
                    { type: "button", className: classNames + " btn-mid", tabIndex: -1 },
                    this.state.selectValue
                ),
                _react2.default.createElement(
                    "button",
                    { type: "button", className: classNames + buttonClass + " btn-inc btn-button-link", onClick: this.increment, tabIndex: 0 },
                    _react2.default.createElement("img", { src: _plusButton2.default, className: "plusButton", alt: "Increase Item Option Quantity" })
                )
            );
        }
    }]);

    return Counter2;
}(_react2.default.Component);

exports.default = Counter2;


//////////////////
// WEBPACK FOOTER
// ./src/components/generic/Counter2.jsx
// module id = 483
// module chunks = 0